import { BasemapImagery, Token } from "@/utils/constant/settings_constantes";
import API from '@/utils/API.js';

let isConfigLoaded = false;
let serverConfig = {};
const debug = window.location.search == "?debug=1";

/**
 * Récupère la configuration serveur.
 * @returns {Promise<Object>} La configuration du serveur.
 */
export async function getServerConfig() {
  if (isConfigLoaded) {
    if (debug) console.log("FrontConfig déjà chargée", serverConfig);
    return serverConfig;
  }

  try {
    serverConfig = await fetchConfigFromServer();
    filterBasemapIfOffline(serverConfig);
    if (debug) console.log("FrontConfig chargée", serverConfig);
    isConfigLoaded = true;
  } catch (error) {
    console.error("Erreur lors du chargement de la configuration du serveur:", error);
  }

  return serverConfig;
}

/**
 * Récupère la configuration du serveur depuis l'API.
 * @returns {Promise<Object>} Données de configuration ou valeurs par défaut en cas d'erreur.
 */
async function fetchConfigFromServer() {
  try {
    const response = await API.get("frontconfig", {});
    
    if (debug) console.log("Réponse récupérée depuis /frontconfig", response);
    
    if (!response || typeof response !== "object") {
      throw new Error("Réponse invalide du serveur.");
    }

    return response;
  } catch (error) {
    console.warn("Impossible de récupérer la configuration du serveur :", error);
    return getDefaultConfig();
  }
}

/**
 * Retourne la configuration par défaut.
 * @returns {Object} Configuration par défaut.
 */
function getDefaultConfig() {
  return {
    isOnline: true,
    isCesiumIonConnected: false,
    basemap: BasemapImagery,
    token: Token,
  };
}

/**
 * Filtre les fonds de carte si le mode offline est activé.
 * @param {Object} config Configuration du serveur.
 */
function filterBasemapIfOffline(config) {
  if (!config.isOnline || !config.isCesiumIonConnected) {
    config.basemap = Object.fromEntries(
      Object.entries(config.basemap).filter(([, basemap]) => basemap.type !== "ion")
    );
  }
}

/**
 * Sélectionne un token unique parmi une liste ou retourne une chaîne de caractères si applicable.
 * @param {string | string[]} token Liste de tokens ou token unique.
 * @returns {string} Token sélectionné.
 */
function filterUniqueToken(token) {
  if (Array.isArray(token) && token.length > 0) {
    return token[Math.floor(Math.random() * token.length)];
  } else if (typeof token === "string" && token.trim() !== "") {
    return token;
  }

  console.warn("Aucun token valide trouvé");
  serverConfig.isCesiumIonConnected = false;
  return "";
}

/**
 * Vérifie si une variable est un objet non vide.
 * @param {*} value Valeur à tester.
 * @returns {boolean} Vrai si c'est un objet valide.
 */
function isValidObject(value) {
  return value && typeof value === "object" && Object.keys(value).length > 0;
}

export default getServerConfig;
